import api from "@/plugins/axios";
import router from "@/router/index";
import { useGlobalStore } from "@/stores";

const actions = () => ({
  async createEmployability(payload) {
    await api.post("/api/employability/create", payload);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "Employability has been successfully created",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    router.push("/employability/overview");
  },

  async editEmployability(payload) {
    await api.post(`/api/employability/${payload.id}`, payload.data);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "All changes have been saved!",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    // router.push("/dashboard");
  },

  async getEmployabilityOverview(payload) {
    const res = await api.get("/api/employability/overview", {
      params: payload,
    });
    this.overview = res.data.content;
    this.pagination.totalItems = res.data.totalElements;
    this.pagination.cuurentPage = res.data.number + 1;
    this.pagination.pageCount = res.data.totalPages;
  },

  async getEmployabilityServiceOverview(payload) {
    const res = await api.get("/api/employability/service-overview", {
      params: payload,
    });
    this.serviceOverview = res.data.content;
    this.serviceOverviewPagination.totalItems = res.data.totalElements;
    this.serviceOverviewPagination.currentPage = res.data.number + 1;
    this.serviceOverviewPagination.pageCount = res.data.totalPages;
  },

  async downloadExcel(payload) {
    try {
      const response = await api.get("/api/employability/overview/export", {
        params: payload,
        responseType: "blob",
      });

      return response;
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  },

  async getEmployability(payload) {
    const res = await api.get(`/api/employability/${payload.id}`);
    return res.data;
  },

  async getEmployabilityDashboard() {
    const res = await api.get("/api/embed/dashboard/7");

    return res.data;
  },

  async deleteEmployability(payload) {
    await api.post(`/api/employability/${payload.id}/delete`);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "The employability service has been deleted",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    router.push("/employability/overview");
  },

  resetAction() {
    this.filters.keyword = null;
    this.filters.advanced = {
      title: null,
      service: [],
      branch: null,
      beneficiary: [],
      emplOfficerId: [],
      date: [],
      hasCV: null,
      relocate: null,
      languages: [],
      languageLevels: [],
      hasDrivingLicense: null,
      drivingLicense: null,
      projects: [],
    };
  },
});

export default actions;
